import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../state/hooks'
import { selectIsFulfilmentPopoverOpen } from '../../../state/slices/uiStateSlice'
import { isMarkedAsUnfulfilled, isValidCustomer } from '../../../functions/sale'
import {
  selectSaleCustomer,
  selectSaleStatus,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { getFeatureFromCache } from '../../../util/feature-cache'
import { isMissingContactInfo } from '../sale-line-item/fulfilment/popover/LineItemFulfillmentUtils'

/**
 * Hook to check if a sale is unfullfilled and the customer is invalid / missing contact details
 */
export const useUnfulfilledSaleInvalidCustomer = () => {
  const isFulfillmentPopoverOpen = useAppSelector(selectIsFulfilmentPopoverOpen)
  const saleStatus = useAppSelector(selectSaleStatus)
  const saleCustomer = useAppSelector(selectSaleCustomer)
  const ffFulfillmentLifB3 = getFeatureFromCache('fulfillment_lif_b3')
  const ffFulfillmentLifBugFixes = getFeatureFromCache(
    'fulfillment_lif_bug_fixes'
  )
  const [isInvalidCustomer, setIsInvalidCustomer] = useState(false)
  const [isMissingCustomerContact, setIsMissingCustomerContact] = useState(
    false
  )

  useEffect(() => {
    const result =
      ffFulfillmentLifB3 &&
      isMarkedAsUnfulfilled(saleStatus) &&
      !isValidCustomer(saleCustomer)

    setIsInvalidCustomer(result)
  }, [ffFulfillmentLifB3, saleStatus, saleCustomer])

  useEffect(() => {
    let isMissingCustomerContactInfo = false
    if (ffFulfillmentLifBugFixes) {
      isMissingCustomerContactInfo =
        ffFulfillmentLifB3 &&
        isMarkedAsUnfulfilled(saleStatus) &&
        isValidCustomer(saleCustomer) &&
        isMissingContactInfo(saleCustomer)
    } else {
      isMissingCustomerContactInfo =
        ffFulfillmentLifB3 &&
        isMarkedAsUnfulfilled(saleStatus) &&
        !!saleCustomer &&
        isMissingContactInfo(saleCustomer)
    }

    setIsMissingCustomerContact(isMissingCustomerContactInfo)
  }, [ffFulfillmentLifB3, ffFulfillmentLifBugFixes, saleStatus, saleCustomer])

  return {
    isFulfillmentPopoverOpen,
    isUnfulfilledSaleInvalidCustomer: isInvalidCustomer,
    isUnfulfilledSaleMissingCustomerContact: isMissingCustomerContact,
  }
}
